export const UserReducerInitialState = {
  usersById: {},
  loadingAll: false,
  estheticians: [],
  estheticiansLoaded: false,
  estheticianProfilesById: {},
};
